import { fetchFormConfigurations } from "../../inputFormConfigurations";
export const Default = () => ({
 passwordFormConfiguration: fetchFormConfigurations([
    "password",
    "newPassword",
    "confirm",
  ]),
});
